export const AUTH_ERROR_MESSAGE = {
    DEFAULT: '很抱歉通知您，您尚未登陸帳號，請返回註冊頁再次嘗試註冊，謝謝您！',
}
